import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api, centsToUSD } from "@/lib/api";
import { useT } from "@/context/ContentContext";
import { Sparkles, Check } from "lucide-react";

export default function Tuition() {
  const t = useT();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/tuition")
      .then((r) => setPlans(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <main className="mx-auto max-w-7xl w-full px-6 py-16 flex-1">
        <div className="overline mb-3">{t("tuition.page.overline", "Tuition")}</div>
        <h1 className="font-display uppercase text-4xl sm:text-5xl text-chrome">{t("tuition.page.title", "Pick Your Plan")}</h1>
        <p className="mt-4 text-white/65 max-w-2xl">{t("tuition.page.subtitle", "")}</p>

        {loading ? (
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {[0,1,2].map((i) => <div key={i} className="card-dark p-8 h-72 animate-pulse" />)}
          </div>
        ) : (
          <div className="mt-12 grid md:grid-cols-3 gap-6" data-testid="tuition-plans-grid">
            {plans.map((p, i) => (
              <div key={p.id} className={`card-dark p-7 relative ${i === 1 ? "border-[#00E5FF]/40" : ""}`} data-testid={`tuition-plan-${p.id}`}>
                {i === 1 && (
                  <div className="absolute -top-3 left-7 px-3 py-1 rounded-full bg-gradient-to-r from-[#0055FF] to-[#00E5FF] text-[10px] uppercase tracking-[0.25em]">
                    Most Popular
                  </div>
                )}
                <div className="flex items-center gap-2">
                  <Sparkles className="text-[#00E5FF]" size={16} />
                  <div className="font-varsity text-2xl tracking-wider">{p.name}</div>
                </div>
                <div className="mt-4 font-display text-5xl text-chrome leading-none">
                  {centsToUSD(p.price_cents)}
                  <span className="text-base text-white/40 font-body normal-case tracking-normal"> / {p.cadence}</span>
                </div>
                <p className="mt-3 text-white/65 text-sm leading-relaxed">{p.description}</p>

                {Array.isArray(p.features) && p.features.length > 0 && (
                  <ul className="mt-5 space-y-2">
                    {p.features.map((f, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-white/75">
                        <Check size={14} className="mt-1 text-[#00E5FF] shrink-0" /> {f}
                      </li>
                    ))}
                  </ul>
                )}

                <button className="btn-ghost w-full mt-7" disabled data-testid={`tuition-enroll-${p.id}`}>
                  Coming Soon
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="mt-14 card-dark p-6 sm:p-8" data-testid="tuition-faq">
          <div className="overline mb-2">{t("tuition.page.faq_overline", "Heads up")}</div>
          <p className="text-white/70 leading-relaxed">{t("tuition.page.faq_body", "")}</p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
